import { render, staticRenderFns } from "./districtRanking.vue?vue&type=template&id=02859958&scoped=true"
import script from "./districtRanking.vue?vue&type=script&lang=js"
export * from "./districtRanking.vue?vue&type=script&lang=js"
import style0 from "./districtRanking.vue?vue&type=style&index=0&id=02859958&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02859958",
  null
  
)

export default component.exports